<template>
    <section>
        <PageTitle title="Dashboard" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'//',title:'Dashboard'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <AllRestaurants
                            @update:selectedRestaurantId="fetchBranchesOfRestaurant"
                            :placeholder="'All'"
                            :return-value="'all'"
                            :updateSelectedRestaurant="selectedRestaurant"
                        />
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Branches</label>
                        <select v-on:change="loadGraphsWithDefaultValues()" class="form-control" v-model="selectedBranch">
                            <option value="all">All</option>
                            <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id+'_branchchoose'">
                                {{branch.areasByAreaId.name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>City</label>
                        <select :disabled="selectedBranch !== 'all'" v-on:change="loadGraphsWithDefaultValues()" v-model="selectedCity" class="form-control">
                            <option value="all">All</option>
                            <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id+'_citychoose'">
                                {{city.city}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Date Range</label>
                        <input type="text" readonly="readonly" data-graph-id="10" placeholder="Select Date Range" class="form-control date_picker"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3">
                    <div class="widget style1 blue-bg">
                        <div class="row">
                            <div class="col-xs-4">
                                <i class="fa fa-shopping-cart fa-5x"></i>
                            </div>
                            <div class="col-xs-8 text-right">
                                <span> Total Orders </span>
                                <h2 class="font-bold counter" v-bind:data-count="topStats.totalOrders">0</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="widget style1 navy-bg">
                        <div class="row">
                            <div class="col-xs-4">
                                <i class="fa fa-dollar fa-5x"></i>
                            </div>
                            <div class="col-xs-8 text-right">
                                <span> Total Sales </span>
                                <h2 class="font-bold counter" v-bind:data-count="topStats.totalSales.toFixed(2)">0</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="widget style1 red-bg">
                        <div class="row">
                            <div class="col-xs-4">
                                <i class="fa fa-cart-arrow-down fa-5x"></i>
                            </div>
                            <div class="col-xs-8 text-right">
                                <span> Order Cancelled </span>
                                <h2 class="font-bold counter" v-bind:data-count="topStats.cancelledOrders">0</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="widget style1 yellow-bg">
                        <div class="row">
                            <div class="col-xs-4">
                                <i class="fa fa-bug fa-5x"></i>
                            </div>
                            <div class="col-xs-8 text-right">
                                <span> Complaints </span>
                                <h2 class="font-bold counter" v-bind:data-count="topStats.complaints">0</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="col-lg-3">-->
                <!--<div class="ibox float-e-margins">-->
                <!--<div class="ibox-title">-->
                <!--&lt;!&ndash;<span class="label label-success pull-right">Monthly</span>&ndash;&gt;-->
                <!--<h5>Orders</h5>-->
                <!--</div>-->
                <!--<div class="ibox-content">-->
                <!--<h1 class="no-margins counter" data-count="40886200">0</h1>-->
                <!--&lt;!&ndash;<div class="stat-percent font-bold text-success">98% <i class="fa fa-bolt"></i></div>&ndash;&gt;-->
                <!--<small>Total Orders Till Now!</small>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="col-lg-3">-->
                <!--<div class="ibox float-e-margins">-->
                <!--<div class="ibox-title">-->
                <!--&lt;!&ndash;<span class="label label-info pull-right">Annual</span>&ndash;&gt;-->
                <!--<h5>Sales ($)</h5>-->
                <!--</div>-->
                <!--<div class="ibox-content">-->
                <!--<h1 class="no-margins counter" data-count="275800">0</h1>-->
                <!--&lt;!&ndash;<div class="stat-percent font-bold text-info">20% <i class="fa fa-level-up"></i></div>&ndash;&gt;-->
                <!--<small>Total Sales Till Now!</small>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="col-lg-3">-->
                <!--<div class="ibox float-e-margins">-->
                <!--<div class="ibox-title">-->
                <!--&lt;!&ndash;<span class="label label-primary pull-right">Today</span>&ndash;&gt;-->
                <!--<h5>Cancellations</h5>-->
                <!--</div>-->
                <!--<div class="ibox-content">-->
                <!--<h1 class="no-margins counter" data-count="106120">0</h1>-->
                <!--&lt;!&ndash;<div class="stat-percent font-bold text-navy">44% <i class="fa fa-level-up"></i></div>&ndash;&gt;-->
                <!--<small>Orders Cancelled Till Now</small>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="col-lg-3">-->
                <!--<div class="ibox float-e-margins">-->
                <!--<div class="ibox-title">-->
                <!--&lt;!&ndash;<span class="label label-danger pull-right">Low value</span>&ndash;&gt;-->
                <!--<h5>Complaints</h5>-->
                <!--</div>-->
                <!--<div class="ibox-content">-->
                <!--<h1 class="no-margins counter" data-count="80600">0</h1>-->
                <!--&lt;!&ndash;<div class="stat-percent font-bold text-danger">38% <i class="fa fa-level-down"></i></div>&ndash;&gt;-->
                <!--<small>Total Complaints Till Now</small>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Date-wise Sales
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <input type="text" readonly="readonly" data-graph-id="1" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <highCharts :options="dateWiseSalesChartInfo.chart"></highCharts>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Branch-Wise Orders
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <input type="text" readonly="readonly" data-graph-id="2" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <highCharts :options="branchWiseOrders.chart"></highCharts>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Top 10 Products Stats
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <input type="text" readonly="readonly" data-graph-id="4" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <highCharts :options="top10Products.chart"></highCharts>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Top 10 Delivery Areas
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <input type="text" readonly="readonly" data-graph-id="6" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <highCharts :options="top10Areas.chart"></highCharts>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <!--                <div class="col-md-6">-->
                <!--                    <div class="panel panel-primary">-->
                <!--                        <div class="panel-heading">-->
                <!--                            Bottom 10 Products Stats-->
                <!--                        </div>-->
                <!--                        <div class="panel-body">-->
                <!--                            <div class="row">-->
                <!--                                <div class="col-md-12">-->
                <!--                                    <div class="form-group">-->
                <!--                                        <label>Date Range</label>-->
                <!--                                        <input type="text" readonly="readonly" data-graph-id="5" placeholder="Select Date Range" class="form-control date_picker"/>-->
                <!--                                    </div>-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                            <div class="row">-->
                <!--                                <highCharts :options="bottom10Products.chart"></highCharts>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Top 10 Customers
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <input type="text" readonly="readonly" data-graph-id="7" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <highCharts :options="top10Customers.chart"></highCharts>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            New Customers Per Month
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>From Year</label>
                                                <select class="form-control" v-model="fromYearCustomer">
                                                    <option v-bind:value="currentYear">{{currentYear}}</option>
                                                    <option v-for="index in 5" v-bind:value="currentYear-(index)">{{currentYear-(index)}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>From Month</label>
                                                <select class="form-control" v-model="fromMonthCustomer">
                                                    <option v-bind:value="1">{{$moment(1, 'M').format('MMMM')}}</option>
                                                    <option v-for="index in 11" v-bind:value="index+1">{{$moment(index+1, 'M').format('MMMM')}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>To Year</label>
                                                <select class="form-control" v-model="toYearCustomer">
                                                    <option v-bind:value="currentYear">{{currentYear}}</option>
                                                    <option v-for="index in 5" v-bind:value="currentYear-(index)">{{currentYear-(index)}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>To Month</label>
                                                <select class="form-control" v-model="toMonthCustomer">
                                                    <option v-bind:value="1">{{$moment(1, 'M').format('MMMM')}}</option>
                                                    <option v-for="index in 11" v-bind:value="index+1">{{$moment(index+1, 'M').format('MMMM')}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" style="margin-top: 25px">
                                    <button class="btn btn-sm btn-primary" v-on:click="updateMonthlyNewCustomersGraphs()"> <i class="fa fa-refresh"></i> UPDATE</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <highCharts :options="monthlyNewCustomers.chart"></highCharts>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Monthly / Yearly Sales
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>From</label>
                                        <select class="form-control" v-model="fromYearYearly">
                                            <option v-bind:value="currentYear">{{currentYear}}</option>
                                            <option v-for="index in 5" v-bind:value="currentYear-(index)">{{currentYear-(index)}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>To</label>
                                        <select class="form-control" v-model="toYearYearly">
                                            <option v-bind:value="currentYear">{{currentYear}}</option>
                                            <option v-for="index in 5" v-bind:value="currentYear-(index)">{{currentYear-(index)}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2" style="margin-top: 25px">
                                    <button class="btn btn-sm btn-primary" v-on:click="updateMonthlyAndYearlyGraph()"> <i class="fa fa-refresh"></i> UPDATE</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <highCharts :options="monthlyYearlySales.chart"></highCharts>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Month Wise Yearly Sales
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>From Year</label>
                                                <select class="form-control" v-model="fromYear">
                                                    <option v-bind:value="currentYear">{{currentYear}}</option>
                                                    <option v-for="index in 5" v-bind:value="currentYear-(index)">{{currentYear-(index)}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>From Month</label>
                                                <select class="form-control" v-model="fromMonth">
                                                    <option v-bind:value="1">{{$moment(1, 'M').format('MMMM')}}</option>
                                                    <option v-for="index in 11" v-bind:value="index+1">{{$moment(index+1, 'M').format('MMMM')}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>To Year</label>
                                                <select class="form-control" v-model="toYear">
                                                    <option v-bind:value="currentYear">{{currentYear}}</option>
                                                    <option v-for="index in 5" v-bind:value="currentYear-(index)">{{currentYear-(index)}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>To Month</label>
                                                <select class="form-control" v-model="toMonth">
                                                    <option v-bind:value="1">{{$moment(1, 'M').format('MMMM')}}</option>
                                                    <option v-for="index in 11" v-bind:value="index+1">{{$moment(index+1, 'M').format('MMMM')}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" style="margin-top: 25px">
                                    <button class="btn btn-sm btn-primary" v-on:click="updateMonthlySalesGraphs()"> <i class="fa fa-refresh"></i> UPDATE</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <highCharts :options="monthlySales.chart"></highCharts>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Complaints Stats
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Date Range Filter</label>
                                        <input type="text" readonly="readonly" data-graph-id="8" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <highCharts :options="complaintChart.chart"></highCharts>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            Branch-Wise Complaints
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <input type="text" readonly="readonly" data-graph-id="9" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <highCharts :options="branchWiseComplaints.chart"></highCharts>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                             Take Away & Delivery Orders
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <input type="text" readonly="readonly" data-graph-id="11" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <highCharts :options="takeAwayAndDeliveryOrders.chart"></highCharts>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="panel panel-primary" v-if="loggedInUserRole === 'ADMIN'">
                        <div class="panel-heading">
                            Agents target per month stats
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <input type="text" readonly="readonly" data-graph-id="12" placeholder="Select Date Range" class="form-control date_picker"/>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="form-group ">
                                        <label>Agents</label>
                                        <multiselect
                                        v-model="selectedAgent"
                                        :options="Agents"
                                        label="fullName"
                                        track-by="fullName"
                                        :hide-selected="true"
                                        :max="10"
                                        :multiple="true"
                                        placeholder="Select agent (Limit 10)"
                                        ></multiselect>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-info btn-sm" v-on:click="UpdateAgentWiseStatsChart()"><i class="fa fa-search"></i> search</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <highCharts :options="AgentWiseStats.chart"></highCharts>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
    <CustomerDetails ref="CustomerDetailsPopUp"/>
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import CustomerDetails from '@/components/customers/CustomerDetails'
    import Multiselect from 'vue-multiselect'
    import Highcharts from 'highcharts'
    import {Chart} from 'highcharts-vue'
    import AllRestaurants from "../components/restaurants/AllRestaurants";

    export default {
        name: "Home",
        data: function() {
            return {
                allUsers:[],
                agent_ids: [],
                selectedAgent: [],

                start:" ",
                end: " ",
                topStats:{
                    totalOrders: 0,
                    totalSales: 0,
                    cancelledOrders:0,
                    complaints: 0,
                },
                loggedInUserRole: "",
                currentYear: new Date().getFullYear(),
                selectedRestaurant: "all",
                selectedBranch: "all",
                selectedCity: "all",
                globalStartDate: this.$moment().subtract(15, 'days').format("YYYY-MM-DD"),
                globalEndDate: this.$moment().format("YYYY-MM-DD"),
                fromYearYearly: new Date().getFullYear(),
                toYearYearly: new Date().getFullYear(),

                toYear: new Date().getFullYear(),
                toMonth:12,
                fromYear: new Date().getFullYear(),
                fromMonth:1,

                toYearCustomer: new Date().getFullYear(),
                toMonthCustomer:12,
                fromYearCustomer: new Date().getFullYear(),
                fromMonthCustomer:1,
                topCustomersIds:[],

                restaurants: [],
                branches: [],
                cities: [],
                dateWiseSalesChartInfo: {
                    stats: {},
                    filters:{start: this.$moment().subtract(15, 'days').format("YYYY-MM-DD"), end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        title: {
                            text: 'Sale Chart'
                        },

                        subtitle: {
                            text: 'Date-Wise Sale Chart'
                        },

                        yAxis: {
                            title: {
                                text: 'Sales'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>{point.y:.1f} Rs.</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            series: {
                                label: {
                                    connectorAllowed: false
                                }
                            }
                        },
                        xAxis: {
                            // type: 'datetime',
                            labels: {
                                formatter: function() {
                                  //   return Highcharts.dateFormat('%d-%b-%Y',this.value);
                                    return moment(this.value).format('DD, MMM YY');
                                }
                            },
                          // categories: ["2023-06-05T16:47:45", "2023-06-08T17:46:29"]
                          categories: []
                        },
                        series: [{
                            name: 'Dates',
                            // pointStart: Date.UTC(2010, 0, 1),
                            // pointInterval: 24 * 3600 * 1000,
                            // data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
                            data: []
                        }],
                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    legend: {
                                        layout: 'horizontal',
                                        align: 'center',
                                        verticalAlign: 'bottom'
                                    }
                                }
                            }]
                        }
                    }
                },
                branchWiseOrders:{
                    stats: {},
                    filters:{start:this.$moment().subtract(1, 'year').format("YYYY-MM-DD"), end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        chart: {
                            plotBackgroundColor: null,
                            plotBorderWidth: null,
                            plotShadow: false,
                            type: 'pie'
                        },
                        title: {
                            text: '# of Orders In Branches'
                        },
                        tooltip: {
                            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: true,
                                    format:'<b>{point.name}</b> : {point.y:f} ({point.percentage:.1f} %)',
                                    // '<b>{point.name}</b>: {point.y:.1f} : {point.percentage:.1f} %',
                                    style: {
                                        color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                }
                            }
                        },
                        series: [{
                            name: 'Brands',
                            colorByPoint: true,
                            data: []
                            // data: [{
                            //     name: 'Johar Town',
                            //     selected: true,
                            //     y: 61,
                            // }, {
                            //     name: 'MM Alam road',
                            //     y: 125
                            // }, {
                            //     name: 'D.H.A',
                            //     y: 52
                            // }, {
                            //     name: 'Ravi Pull',
                            //     y: 136
                            // }]
                        }]
                    }
                },
                monthlyYearlySales: {
                    stats: {},
                    chart: {
                        chart: {
                            type: 'column'
                        },
                        title: {
                            text: 'Monthly / Yearly Sales'
                        },
                        xAxis: {
                            categories: [
                                'Jan',
                                'Feb',
                                'Mar',
                                'Apr',
                                'May',
                                'Jun',
                                'Jul',
                                'Aug',
                                'Sep',
                                'Oct',
                                'Nov',
                                'Dec'
                            ],
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: 'Sales'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>{point.y:.1f} Rs.</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        series: [{
                            name: 'Monthly Sales',
                            // data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4]

                        }]
                    }
                },
                monthlySales: {
                    stats: {},
                    chart: {
                        title: {
                            text: 'Monthly Sales Chart'
                        },

                        yAxis: {
                            title: {
                                text: 'Sales'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>{point.y:.1f} Rs.</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            series: {
                                label: {
                                    connectorAllowed: false
                                }
                            }
                        },
                        xAxis: {
                            categories: [
                                'Jan',
                                'Feb',
                                'Mar',
                                'Apr',
                                'May',
                                'Jun',
                                'Jul',
                                'Aug',
                                'Sep',
                                'Oct',
                                'Nov',
                                'Dec'
                            ],
                            crosshair: true
                        },

                        series: [{
                            name: 'Monthly Sales',
                        }],
                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    legend: {
                                        layout: 'horizontal',
                                        align: 'center',
                                        verticalAlign: 'bottom'
                                    }
                                }
                            }]
                        }
                    }
                },
                monthlyNewCustomers: {
                    stats: {},
                    chart: {
                        title: {
                            text: 'New Customers Per Month'
                        },

                        yAxis: {
                            title: {
                                text: 'No. of Customers'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>{point.y:f} New Customers</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            series: {
                                label: {
                                    connectorAllowed: false
                                }
                            }
                        },
                        xAxis: {
                            categories: [
                                'Jan',
                                'Feb',
                                'Mar',
                                'Apr',
                                'May',
                                'Jun',
                                'Jul',
                                'Aug',
                                'Sep',
                                'Oct',
                                'Nov',
                                'Dec'
                            ],
                            crosshair: true
                        },

                        series: [{
                            name: 'Monthly Customers',
                        }],
                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    legend: {
                                        layout: 'horizontal',
                                        align: 'center',
                                        verticalAlign: 'bottom'
                                    }
                                }
                            }]
                        }
                    }
                },
                top10Products: {
                    stats: {},
                    filters:{start:this.$moment().subtract(15, 'days').format("YYYY-MM-DD"), end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        chart: {
                            type: 'column'
                        },
                        title: {
                            text: 'Top 10 Products'
                        },
                        xAxis: {
                            categories: [
                                'Son Of A Bun',
                                'Shrowmin',
                                'Smoking',
                                'Onion Rings',
                                'Molten Lava',
                                'Hara Bhara Qeema',
                                'Hareesa',
                                'Naan Chaney',
                                'Mango Lassi',
                                'Siri Payee'
                            ],
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: '# Of Units Sold'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>{point.y:.1f} Sold</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        series: [{
                            name: 'Top 10 Products',
                            color:"#f28f43",
                            data: [49, 71, 106, 129, 144, 176, 135, 148, 216, 194]

                        }]
                    }
                },
                bottom10Products: {
                    stats: {},
                    filters:{start:this.$moment().subtract(15, 'days').format("YYYY-MM-DD"), end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        chart: {
                            type: 'column'
                        },
                        title: {
                            text: 'Bottom 10 Products'
                        },
                        xAxis: {
                            categories: [
                                'Son Of A Bun',
                                'Shrowmin',
                                'Smoking',
                                'Onion Rings',
                                'Molten Lava',
                                'Hara Bhara Qeema',
                                'Hareesa',
                                'Naan Chaney',
                                'Mango Lassi',
                                'Siri Payee'
                            ],
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: '# Of Units Sold'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>{point.y:.1f} Sold</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        series: [{
                            name: 'Top 10 Products',
                            color:"#f25a5c",
                            data: [49, 71, 106, 129, 144, 176, 135, 148, 216, 194]

                        }]
                    }
                },
                top10Areas: {
                    stats: {},
                    filters:{start:this.$moment().subtract(15, 'days').format("YYYY-MM-DD"), end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        chart: {
                            type: 'column'
                        },
                        title: {
                            text: 'Top 10 Delivery Areas'
                        },
                        xAxis: {
                            categories: [
                                'Son Of A Bun',
                                'Shrowmin',
                                'Smoking',
                                'Onion Rings',
                                'Molten Lava',
                                'Hara Bhara Qeema',
                                'Hareesa',
                                'Naan Chaney',
                                'Mango Lassi',
                                'Siri Payee'
                            ],
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: '# Of Orders Delivered'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>{point.y:.1f} Orders Delivered</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        series: [{
                            name: 'Top 10 Areas',
                            color:"#42f288",
                            data: [49, 71, 106, 129, 144, 176, 135, 148, 216, 194]

                        }]
                    }
                },
                top10Customers: {
                    stats: {},
                    filters: {
                        start: this.$moment().subtract(15, 'days').format("YYYY-MM-DD"),
                        end: this.$moment().format("YYYY-MM-DD")
                    },
                    chart: {
                        chart: {
                            type: 'column'
                        },
                        title: {
                            text: 'Top 10 Customers'
                        },
                        xAxis: {
                            categories: [
                                'Son Of A Bun',
                                'Shrowmin',
                                'Smoking',
                                'Onion Rings',
                                'Molten Lava',
                                'Hara Bhara Qeema',
                                'Hareesa',
                                'Naan Chaney',
                                'Mango Lassi',
                                'Siri Payee'
                            ],
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: '# Of Orders Placed'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>Placed Orders: {point.y:.1f}</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                point: {
                                    events: {
                                        click: ({point}) => {
                                            let customerId=this.topCustomersIds[point.x];
                                            this.loadCustomerDetails(customerId);
                                        }
                                    }
                                }
                            },
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        series: [{
                            name: 'Top 10 Customers',
                            color: "#5751f2",
                            data: [49, 71, 106, 129, 144, 176, 135, 148, 216, 194]

                        }]
                    },
                },
                branchWiseComplaints:{
                    stats: {},
                    filters:{start:this.$moment().subtract(1, 'year').format("YYYY-MM-DD"), end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        chart: {
                            plotBackgroundColor: null,
                            plotBorderWidth: null,
                            plotShadow: false,
                            type: 'pie'
                        },
                        title: {
                            text: '# of Complaints In Branches'
                        },
                        tooltip: {
                            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: true,
                                    format:'<b>{point.name}</b> : {point.y:f} ({point.percentage:.1f} %)',
                                    style: {
                                        color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                }
                            }
                        },
                        series: [{
                            name: 'Brands',
                            colorByPoint: true,
                            data: []
                        }]
                    }
                },
                complaintChart: {
                    stats: {},
                    filters:{start:this.$moment().subtract(1, 'year').format("YYYY-MM-DD"), end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        title: {
                            text: 'Complaints Statistics'
                        },

                        yAxis: {
                            title: {
                                text: '# Of Complaints Received'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' +
                                '<td style="padding:0"><b>{point.y:.1f} Complaints</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            series: {
                                label: {
                                    connectorAllowed: false
                                }
                            }
                        },
                        xAxis: {
                            type: 'datetime',
                            labels: {
                                formatter: function() {
                                    return Highcharts.dateFormat('%d-%b-%Y', this.value);
                                }
                            }
                        },
                        series: [{
                            name: 'Dates',
                            pointStart: Date.UTC(2010, 0, 1),
                            pointInterval: 24 * 3600 * 1000, // one day
                            data: [27,48,34,33,37,49,30,45,38,31,29,39,25,47,26,42,43,35,44,32,46,36,40,41,50,28]
                        }],
                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    legend: {
                                        layout: 'horizontal',
                                        align: 'center',
                                        verticalAlign: 'bottom'
                                    }
                                }
                            }]
                        }
                    }
                },
                takeAwayAndDeliveryOrders:{
                    stats: {},
                    filters:{
                        start: this.$moment().subtract(15, 'days').format("YYYY-MM-DD"),
                        end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        chart: {
                            plotBackgroundColor: null,
                            plotBorderWidth: null,
                            plotShadow: false,
                            type: 'pie'
                        },
                        title: {
                            text: '# of Take Away & Delivery Orders'
                        },
                        tooltip: {
                            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: true,
                                    format:'<b>{point.name}</b> : {point.y:f} ({point.percentage:.1f} %)',
                                    // '<b>{point.name}</b>: {point.y:.1f} : {point.percentage:.1f} %',
                                    style: {
                                        color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                    }
                                }
                            }
                        },
                        series: [{
                            name: 'Brands',
                            colorByPoint: true,
                            data: []
                            // data: [{
                            //     name: 'Johar Town',
                            //     selected: true,
                            //     y: 61,
                            // }, {
                            //     name: 'MM Alam road',
                            //     y: 125
                            // }, {
                            //     name: 'D.H.A',
                            //     y: 52
                            // }, {
                            //     name: 'Ravi Pull',
                            //     y: 136
                            // }]
                        }]
                    }
                },
                AgentWiseStats: {
                    stats: {},
                    filters:{start:this.$moment().subtract(15, 'days').format("YYYY-MM-DD"), end: this.$moment().format("YYYY-MM-DD")},
                    chart: {
                        chart: {
                            type: 'column'
                        },
                        title: {
                            text: 'Agent wise stats'
                        },
                        xAxis: {
                            categories: [],
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: 'number of new customers'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr>' + '<td style="padding:0"><b>{point.y:.1f} Sold</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        series: [{
                            name: 'Agents',
                            color:"#b7f242",
                            data: []
                        }]
                    }
                },
            }
        },
        components: {
            AllRestaurants,
            PageTitle,
            highCharts: Chart,
            CustomerDetails,
            Multiselect
        },
        created: function () {           
            this.loggedInUserRole = this.$store.state.user.userRolesById[0].role.split('_')[1];
            $("body").removeClass("gray-bg");
            if(this.loggedInUserRole === 'AGENT'){
                this.$router.replace("/orders");
            }
            if(this.loggedInUserRole === 'ADMIN'){
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                    this.restaurants = resp.data;
                });
            }
            else if(this.loggedInUserRole === 'USER' || this.loggedInUserRole === 'FRANCHISE'){
                this.selectedRestaurant = this.$store.state.user.restaurant.id;
                this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name})
                this.fetchBranchesOfRestaurant();
            }
            this.$http.post(this.$store.state.mainAppURL + "areas/get_all_cities").then(resp => {
                this.cities = resp.data;
            });

           

        },
        updated: function(){
            $('.counter').each(function() {
                var $this = $(this),
                    countTo = $this.attr('data-count');

                $({ countNum: $this.text()}).animate({
                        countNum: countTo
                    },

                    {
                        duration: 2000,
                        easing:'linear',
                        step: function() {
                            $this.text(Math.floor(this.countNum));
                        },
                        complete: function() {
                            $this.text(this.countNum);
                            //alert('finished');
                        }

                    });
            });
        },
        computed: {
            Agents: {
            get: function(){
                if(this.selectedRestaurant !== "all" && this.selectedBranch === "all"){
                    //Fetch agents of selected restaurant.
                    let temp= this.allUsers.filter(fn=> {
                        return fn.restaurant !== null && fn.restaurant.id === this.selectedRestaurant && fn.userRolesById[0].role === "ROLE_AGENT";
                    })
                    return temp;
                }
                else if(this.selectedRestaurant !== "all" && this.selectedBranch !== "all"){
                    //fetch agents of selected restaurant of selected branch
                    let temp= this.allUsers.filter(fn=> {
                        return fn.branch !== null && fn.branch.id === this.selectedBranch && fn.userRolesById[0].role === "ROLE_AGENT";
                    })
                    return temp;
                }
                else{
                    //fetch all agents
                    return this.allUsers.filter(fn=> {
                        return fn.userRolesById[0].role === 'ROLE_AGENT';
                    })
                }
            },
            set: function(){
                console.log("Setter");
                return null;}
            },
        },
        mounted: async function () {
            let self = this;
            let datePickerObject = $('.date_picker');

            //Getting selected agents of a restaurant branch
            if(this.selectedBranch=== "all"){
                let resp= await this.$http.get(this.$store.state.mainAppURL + "users/get_all_users_full_name");
                this.allUsers= resp.data;
            }
            else{
                let resp = await this.$http.get(this.$store.state.mainAppURL+ "dashboard/get_all_agents_of_selected_branch");
            }
            datePickerObject.daterangepicker({
                format: 'YYYY-MM-DD',
                startDate: self.$moment().subtract(15, 'days').format("YYYY-MM-DD"),
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                },
            }).on('apply.daterangepicker', function(ev, picker) {

                    $(this).val(picker.startDate.format('DD MMM, YYYY') + ' to ' + picker.endDate.format('DD MMM, YYYY'));
                    self.loadGraphAccordingToDateFilter(picker.startDate.format('YYYY-MM-DD'), picker.endDate.format('YYYY-MM-DD'), $(this).attr("data-graph-id"));

                if ($(this).attr("data-graph-id")==="10") {
                    $('.date_picker').each(function () {
                        $(this).val(picker.startDate.format('DD MMM, YYYY') + ' to ' + picker.endDate.format('DD MMM, YYYY'));
                    });
                }
            }).on('cancel.daterangepicker', function(ev, picker) {
                if ($(this).attr("data-graph-id")==="2" || $(this).attr("data-graph-id")==="8" || $(this).attr("data-graph-id")==="9") {
                    $(this).val(self.$moment().subtract(1, 'year').format("DD MMM, YYYY") + ' to ' + self.$moment().format("DD MMM, YYYY"));
                    self.loadGraphAccordingToDateFilter(self.$moment().subtract(1, 'year').format("YYYY-MM-DD"), self.$moment().format("YYYY-MM-DD"), $(this).attr("data-graph-id"));
                }
                else{
                    $(this).val(self.$moment().subtract(15, 'days').format("DD MMM, YYYY") + ' to ' + self.$moment().format("DD MMM, YYYY"));
                    self.loadGraphAccordingToDateFilter(self.$moment().subtract(15, 'days').format("YYYY-MM-DD"), self.$moment().format("YYYY-MM-DD"), $(this).attr("data-graph-id"));
                }
            });
            $('.date_picker').each(function () {
                if ($(this).attr("data-graph-id")==="2" || $(this).attr("data-graph-id")==="8" || $(this).attr("data-graph-id")==="9") {
                    $(this).val(self.$moment().subtract(1, 'year').format("DD MMM, YYYY") + ' to ' + self.$moment().format("DD MMM, YYYY"));
                }else {
                    $(this).val(self.$moment().subtract(15, 'days').format("DD MMM, YYYY") + ' to ' + self.$moment().format("DD MMM, YYYY"));
                }
            });
            $(".cancelBtn").html("Reset");
            this.loadGraphsWithDefaultValues();
            
        },
        watch: {
            selectedBranch: function () {
                this.selectedBranch !== 'all' && (this.selectedCity = 'all')
            }
        },
        methods: {
            
            loadCustomerDetails:function(customerId){
                let start=this.top10Customers.filters.start;
                let end=this.top10Customers.filters.end;
                let restaurant_id= this.selectedRestaurant;
                let branch_id= this.selectedBranch;
                let city_id= this.selectedCity;
                this.$refs.CustomerDetailsPopUp.load(customerId,start,end,restaurant_id,branch_id,city_id);
            },
            fetchBranchesOfRestaurant: function (event) {
                this.selectedRestaurant = event;
                if(this.selectedRestaurant !== "all"){
                  let params = new URLSearchParams();
                  params.append("restaurant_id", this.selectedRestaurant);
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                        // console.log(resp.data);
                        this.branches = resp.data;
                    });
                }else{
                    this.branches = [];
                }
                this.selectedBranch = "all";
                this.loadGraphsWithDefaultValues();
            },
            loadGraphsWithDefaultValues: function () {
                this.updateDateWiseSalesGraphs();
                this.updateBranchWiseOrderCountGraph();
                this.updateMonthlySalesGraphs();
                this.updateMonthlyNewCustomersGraphs();
                this.updateMonthlyAndYearlyGraph();
                this.updateTop10ProductStats();
                this.updateBottom10Products();
                this.updateTop10DeliveryAreas();
                this.updateTop10CustomerChart();
                this.updateBranchWiseComplaintsGraph();
                this.updateComplaintStats();
                this.loadTopSats();
                this.updateTakeAwayAndDeliveryOrdersGraph();
                this.loadAgentStats();

            },
            
            loadTopSats: function () {
                let params = {
                    start: this.globalStartDate,
                    end: this.globalEndDate,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity
                };
                this.$http.get(this.$store.state.mainAppURL + "dashboard/get_top_stats",{
                    params: params
                }).then(resp => {
                    // console.log("total sales",resp.data.total_sales);
                    this.topStats.totalOrders = resp.data.total_orders;
                    this.topStats.totalSales = (resp.data.total_sales === null) ? 0 : resp.data.total_sales;
                    // console.warn("total sale: "+ this.topStats.totalSales);
                    // console.warn(resp.data.total_sales);
                    this.topStats.cancelledOrders = resp.data.canceled_orders;
                    this.topStats.complaints = resp.data.complaint_count;
                    // console.log(this.topStats);
                });
            },
            GetNames(data){
                var temp= [];
                for(let name of data){
                    temp.push(name.fullName);
                }
                return temp;
            },
            getAgentIds(Agents){
                var ids= [];
                for(let data of Agents){
                    ids.push(data.id.toString());
                }
                return ids;
            },
            loadAgentStats: function(){       
                let params= new URLSearchParams();
                params.append("agent_id" , this.getAgentIds(this.allUsers));
                this.$http.get(this.$store.state.mainAppURL+ "dashboard/get_Top_customer_count", {
                    params: params
                }).then(resp=> {
                    let agents_counts= [];
                    for(let count of resp.data.counts) {
                      agents_counts.push(parseInt(count));
                    }
                    this.AgentWiseStats.chart.xAxis.categories = resp.data.name;
                    this.AgentWiseStats.chart.series[0].data = agents_counts;
                });
            },
            UpdateAgentWiseStatsChart: function(){
                
                if (this.selectedBranch === "all") 
                {
                    this.AgentWiseStats.chart.xAxis.categories= this.GetNames(this.selectedAgent);
                    let params= new URLSearchParams();
                    params.append("start", this.AgentWiseStats.filters.start);
                    params.append("end", this.AgentWiseStats.filters.end);
                    params.append("agent_id", this.getAgentIds(this.selectedAgent));
                    this.$http.get(this.$store.state.mainAppURL + "dashboard/get_customer_count_of_agent",{
                        params: params
                    }).then(resp => {
                        this.AgentWiseStats.chart.series[0].data= resp.data;
                    });
                }
            },
            
            loadGraphAccordingToDateFilter: function (start, end, graphId) {

                switch (graphId) {
                    case "1":
                        this.dateWiseSalesChartInfo.filters.start = start;
                        this.dateWiseSalesChartInfo.filters.end = end;
                        this.updateDateWiseSalesGraphs();
                        break;
                    case "2":
                        this.branchWiseOrders.filters.start = start;
                        this.branchWiseOrders.filters.end = end;
                        this.updateBranchWiseOrderCountGraph();
                        break;
                    case "4":
                        this.top10Products.filters.start = start;
                        this.top10Products.filters.end = end;
                        this.updateTop10ProductStats();
                        break;
                    case "5":
                        this.bottom10Products.filters.start = start;
                        this.bottom10Products.filters.end = end;
                        this.updateBottom10Products();
                        break;
                    case "6":
                        this.top10Areas.filters.start = start;
                        this.top10Areas.filters.end = end;
                        this.updateTop10DeliveryAreas();
                        break;
                    case "7":
                        this.top10Customers.filters.start = start;
                        this.top10Customers.filters.end = end;
                        this.updateTop10CustomerChart();
                        break;
                    case "8":
                        this.complaintChart.filters.start = start;
                        this.complaintChart.filters.end = end;
                        this.updateComplaintStats();
                        break;
                    case "10":
                        this.dateWiseSalesChartInfo.filters.start = start;
                        this.dateWiseSalesChartInfo.filters.end = end;
                        this.updateDateWiseSalesGraphs();

                        this.branchWiseOrders.filters.start = start;
                        this.branchWiseOrders.filters.end = end;
                        this.updateBranchWiseOrderCountGraph();

                        //yearly sales graph
                        this.fromYearYearly = new Date(start).getFullYear();
                        this.toYearYearly = new Date(end).getFullYear();
                        this.updateMonthlyAndYearlyGraph();

                        this.top10Products.filters.start = start;
                        this.top10Products.filters.end = end;
                        this.updateTop10ProductStats();

                        //monthly sales graph
                        this.fromYear = new Date(start).getFullYear();
                        this.fromMonth = new Date(start).getMonth()+1;
                        this.toYear = new Date(end).getFullYear();
                        this.toMonth = new Date(end).getMonth()+1;
                        this.updateMonthlySalesGraphs();

                        this.bottom10Products.filters.start = start;
                        this.bottom10Products.filters.end = end;
                        this.updateBottom10Products();

                        this.top10Areas.filters.start = start;
                        this.top10Areas.filters.end = end;
                        this.updateTop10DeliveryAreas();

                        this.top10Customers.filters.start = start;
                        this.top10Customers.filters.end = end;
                        this.updateTop10CustomerChart();

                        this.complaintChart.filters.start = start;
                        this.complaintChart.filters.end = end;
                        this.updateComplaintStats();

                        //new customers per month
                        this.fromYearCustomer = new Date(start).getFullYear();
                        this.fromMonthCustomer = new Date(start).getMonth()+1;
                        this.toYearCustomer = new Date(end).getFullYear();
                        this.toMonthCustomer = new Date(end).getMonth()+1;
                        this.updateMonthlyNewCustomersGraphs();

                        this.takeAwayAndDeliveryOrders.filters.start = start;
                        this.takeAwayAndDeliveryOrders.filters.end = end;
                        this.updateTakeAwayAndDeliveryOrdersGraph();

                        this.branchWiseComplaints.filters.start = start;
                        this.branchWiseComplaints.filters.end = end;
                        this.updateBranchWiseComplaintsGraph();

                        this.globalStartDate = start;
                        this.globalEndDate = end;
                        this.loadTopSats();
                        break;

                    case "9":
                        this.branchWiseComplaints.filters.start = start;
                        this.branchWiseComplaints.filters.end = end;
                        this.updateBranchWiseComplaintsGraph();
                        break;
                    case "11":
                        this.takeAwayAndDeliveryOrders.filters.start = start;
                        this.takeAwayAndDeliveryOrders.filters.end = end;
                        this.updateTakeAwayAndDeliveryOrdersGraph();
                        break;
                    case "12":
                        this.AgentWiseStats.filters.start= start;
                        this.AgentWiseStats.filters.end= end;
                        this.UpdateAgentWiseStatsChart();
                        break;
                }
            },
            updateDateWiseSalesGraphs: function (){
                let params = {
                    start: this.dateWiseSalesChartInfo.filters.start,
                    end: this.dateWiseSalesChartInfo.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity
                };
                // console.log(params);
                // let startDate = new Date(this.dateWiseSalesChartInfo.filters.start);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/get_date_wise_sales",{
                    params: params
                }).then(resp => {
                    // console.log(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                    this.dateWiseSalesChartInfo.chart.series[0].data = resp.data.series;
                    this.dateWiseSalesChartInfo.chart.xAxis.categories = resp.data.categories;
                    // this.dateWiseSalesChartInfo.chart.series[0].pointStart = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                    // this.dateWiseSalesChartInfo.chart.series[0].pointInterval = 24 * 3600 * 1000;

                });
            },
            updateBranchWiseOrderCountGraph: function(){
                this.selectedBranch !== 'all' && (this.selectedCity = 'all')
                let params = {
                    start: this.branchWiseOrders.filters.start,
                    end: this.branchWiseOrders.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity
                };
                // console.log(params);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/get_branch_wise_count",{
                    params: params
                }).then(resp => {
                    // console.log(resp.data);
                    this.branchWiseOrders.chart.series[0].data = [];
                    for(let d of resp.data){
                        this.branchWiseOrders.chart.series[0].data.push(d);
                    }
                });
            },
            updateMonthlySalesGraphs: function (){
                let startDate = new Date(this.fromYear+"-"+this.fromMonth.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})+"-01");
                let endDate = new Date(this.toYear,this.toMonth.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}),0);
                if (startDate === endDate && this.fromMonth >= this.toMonth){
                    //code for error
                    swal("ERROR!", "Please select valid range of years.", "error");
                }
                else{
                    let params = {
                        start: this.fromYear+"-"+this.fromMonth.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})+"-01",
                        end: endDate.getFullYear() + "-" + (endDate.getMonth()+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})+"-" + endDate.getDate(),
                        restaurant_id: this.selectedRestaurant,
                        branch_id: this.selectedBranch,
                        city_id: this.selectedCity
                    };

                    this.$http.get(this.$store.state.mainAppURL + "dashboard/get_monthly_sales",{
                        params: params
                    }).then(resp => {

                        let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                        let axisCategories=[];

                        for(let i = parseInt(this.fromYear); i <= parseInt(this.toYear); i++){

                            if(parseInt(this.fromYear)===parseInt(this.toYear)){
                                for (let j = (this.fromMonth) - 1; j < (this.toMonth); j++) {
                                    axisCategories.push(months[j] + "-" + i);
                                }
                            }else if (i === parseInt(this.fromYear)) {
                                for (let j = (this.fromMonth) - 1; j < 12; j++) {
                                    axisCategories.push(months[j] + "-" + i);
                                }
                            }else if(i===parseInt(this.toYear)){
                                for (let j = 0; j < this.toMonth; j++) {
                                    axisCategories.push(months[j] + "-" + i);
                                }
                            }else{
                                for (let j = 0; j < 12; j++) {
                                    axisCategories.push(months[j] + "-" + i);
                                }
                            }
                        }
                        // console.log(startDate.getFullYear(), startDate.getMonth()+1, startDate.getDate());
                        this.monthlySales.chart.xAxis.categories = axisCategories;
                        this.monthlySales.chart.series[0].data = resp.data;
                    });
                }
            },
            updateMonthlyNewCustomersGraphs: function (){
                let startDate = new Date(this.fromYearCustomer+"-"+this.fromMonthCustomer.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})+"-01");
                let endDate = new Date(this.toYearCustomer,this.toMonthCustomer.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}),0);
                if (startDate === endDate && this.fromMonthCustomer >= this.toMonthCustomer){
                    //code for error
                    swal("ERROR!", "Please select valid range of years.", "error");
                }
                else{
                    let params = {
                        start: this.fromYearCustomer+"-"+this.fromMonthCustomer.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})+"-01",
                        end: endDate.getFullYear() + "-" + (endDate.getMonth()+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})+"-" + endDate.getDate(),
                        restaurant_id: this.selectedRestaurant,
                        branch_id: this.selectedBranch,
                        city_id: this.selectedCity
                    };

                    this.$http.get(this.$store.state.mainAppURL + "dashboard/get_monthly_new_customers",{
                        params: params
                    }).then(resp => {

                        let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                        let axisCategories=[];

                        for(let i = parseInt(this.fromYearCustomer); i <= parseInt(this.toYearCustomer); i++){

                            if(parseInt(this.fromYearCustomer)===parseInt(this.toYearCustomer)){
                                for (let j = (this.fromMonthCustomer) - 1; j < (this.toMonthCustomer); j++) {
                                    axisCategories.push(months[j] + "-" + i);
                                }
                            }else if (i === parseInt(this.fromYearCustomer)) {
                                for (let j = (this.fromMonthCustomer) - 1; j < 12; j++) {
                                    axisCategories.push(months[j] + "-" + i);
                                }
                            }else if(i===parseInt(this.toYearCustomer)){
                                for (let j = 0; j < this.toMonthCustomer; j++) {
                                    axisCategories.push(months[j] + "-" + i);
                                }
                            }else{
                                for (let j = 0; j < 12; j++) {
                                    axisCategories.push(months[j] + "-" + i);
                                }
                            }
                        }
                        // console.log(startDate.getFullYear(), startDate.getMonth()+1, startDate.getDate());
                        this.monthlyNewCustomers.chart.xAxis.categories = axisCategories;
                        this.monthlyNewCustomers.chart.series[0].data = resp.data;
                    });
                }
            },
            updateMonthlyAndYearlyGraph: function (){
                if(parseInt(this.fromYearYearly) <= parseInt(this.toYearYearly)){
                    let params = {
                        start: this.fromYearYearly,
                        end: this.toYearYearly,
                        restaurant_id: this.selectedRestaurant,
                        branch_id: this.selectedBranch,
                        city_id: this.selectedCity
                    };
                    this.$http.get(this.$store.state.mainAppURL + "dashboard/get_monthly_yearly_sales",{
                        params: params
                    }).then(resp => {
                        let axisCategories = [];
                        if(this.fromYearYearly === this.toYearYearly){
                            axisCategories = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                            this.monthlyYearlySales.chart.title.text = "Monthly Sales Of Year: " + this.fromYearYearly;
                            this.monthlyYearlySales.chart.xAxis.categories = axisCategories;
                            this.monthlyYearlySales.chart.series[0].name = "Monthly Sales";
                            this.monthlyYearlySales.chart.series[0].data = resp.data;
                        }else{
                            for(let i = parseInt(this.fromYearYearly); i <= parseInt(this.toYearYearly); i++){
                                axisCategories.push(i);
                            }
                            this.monthlyYearlySales.chart.title.text = "Yearly Sales Between: " + this.fromYearYearly + " to " + this.toYearYearly;
                            this.monthlyYearlySales.chart.xAxis.categories = axisCategories;
                            this.monthlyYearlySales.chart.series[0].name = "Yearly Sales";
                            this.monthlyYearlySales.chart.series[0].data = resp.data;
                        }
                    });
                }else{
                    swal("ERROR!", "Please select valid range of years.", "error");
                }
            },

            updateTop10ProductStats: function () {
                let params = {
                    start: this.top10Products.filters.start,
                    end: this.top10Products.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity,
                    order: "desc"
                };
                // console.log(params);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/get_products_sale_stats",{
                    params: params
                }).then(resp => {
                    let names=[];
                    if (this.selectedRestaurant==="all"){
                        resp.data.names.forEach((item,index) => {
                            names.push(item + '<br>(' + resp.data.restaurantNames[index] + ')');
                        });
                    }else{
                        names=resp.data.names;
                    }
                    this.top10Products.chart.xAxis.categories = names;
                    this.top10Products.chart.series[0].data = resp.data.counts;

                });
            },

            updateBottom10Products: function () {
                let params = {
                    start: this.bottom10Products.filters.start,
                    end: this.bottom10Products.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity,
                    order: "asc"
                };
                // console.log(params);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/get_products_sale_stats",{
                    params: params
                }).then(resp => {
                    // console.log(resp.data);
                    this.bottom10Products.chart.xAxis.categories = resp.data.names;
                    this.bottom10Products.chart.series[0].data = resp.data.counts;

                });
            },
            updateTop10DeliveryAreas: function (){
                let params = {
                    start: this.top10Areas.filters.start,
                    end: this.top10Areas.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity
                };
                // console.log(params);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/areas_stats",{
                    params: params
                }).then(resp => {
                    // console.log(resp.data);
                    this.top10Areas.chart.xAxis.categories = resp.data.names;
                    this.top10Areas.chart.series[0].data = resp.data.counts;

                });
            },
            updateTop10CustomerChart: function (){
                let params = {
                    start: this.top10Customers.filters.start,
                    end: this.top10Customers.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity
                };
                // console.log(params);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/customer_stats",{
                    params: params
                }).then(resp => {
                    this.topCustomersIds = resp.data.ids;
                    this.top10Customers.chart.xAxis.categories = resp.data.names;
                    this.top10Customers.chart.series[0].data = resp.data.counts;

                });
            },
            updateBranchWiseComplaintsGraph: function(){
                this.selectedBranch !== 'all' && (this.selectedCity = 'all')
                let params = {
                    start: this.branchWiseComplaints.filters.start,
                    end: this.branchWiseComplaints.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity
                };
                // console.log(params);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/get_branch_wise_complaints",{
                    params: params
                }).then(resp => {
                    // console.log("get_branch_wise_complaints",resp.data);
                    this.branchWiseComplaints.chart.series[0].data = [];
                    for(let d of resp.data){
                        this.branchWiseComplaints.chart.series[0].data.push(d);
                    }
                });
            },
            updateComplaintStats: function (){
                let params = {
                    start: this.complaintChart.filters.start,
                    end: this.complaintChart.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity
                };
                // console.log(params);
                let startDate = new Date(this.complaintChart.filters.start);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/get_complaint_stats",{
                    params: params
                }).then(resp => {
                    // console.log(resp.data);
                    this.complaintChart.chart.series[0].data = resp.data;
                    this.complaintChart.chart.series[0].pointStart = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                    this.complaintChart.chart.series[0].pointInterval = 24 * 3600 * 1000;
                });
            },
            updateTakeAwayAndDeliveryOrdersGraph: function(){
                let params = {
                    start: this.takeAwayAndDeliveryOrders.filters.start,
                    end: this.takeAwayAndDeliveryOrders.filters.end,
                    restaurant_id: this.selectedRestaurant,
                    branch_id: this.selectedBranch,
                    city_id: this.selectedCity
                };
                // console.log(params);
                this.$http.get(this.$store.state.mainAppURL + "dashboard/get_takeAway_delivery_orders_count",{
                    params: params
                }).then(resp => {
                    // console.log("takeway and delivery-->",resp.data);
                    this.takeAwayAndDeliveryOrders.chart.series[0].data = [];
                    for(let d of resp.data){
                        this.takeAwayAndDeliveryOrders.chart.series[0].data.push(d);
                    }
                });
            },

        }
    }
</script>

<style scoped>
    .ibox-title{
        border-color: #7852c1 !important;
    }
</style>